export function canViewIssueReport (issue) {
  if (!issue) return false
  if (issue.type !== 'report') throw new Error('Issue is not a report!')
  return issue.status === 'decided' || !issue.isRestrictedView
}
